import { captureException } from '@sentry/react'

// Keep this namespace stable. Introduce future changes with a new release ID.
const STORAGE_VERSION = '2026-11-preview-v1'
let storageErrorReported = false
const keyFor = (scope: string, id: string) => `numeo:feature-intro:${JSON.stringify([STORAGE_VERSION, scope, id])}`
const reportStorageError = (error: unknown) => {
    if (storageErrorReported) return
    storageErrorReported = true
    captureException(error)
}

export const hasSeenRelease = (scope: string, id: string): boolean => {
    try {
        return localStorage.getItem(keyFor(scope, id)) === 'seen'
    } catch (error) {
        reportStorageError(error)
        return false
    }
}
export const markReleaseSeen = (scope: string, id: string): void => {
    try {
        localStorage.setItem(keyFor(scope, id), 'seen')
    } catch (error) {
        reportStorageError(error)
    }
}
